import React, { useEffect, useState } from "react";
import { FormError } from "../../../utils/context/FormErrorContext"
import './ErrorMessages.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
interface ErrorMessagesProps {
  showHeader?: boolean,
  errors: FormError[],
  isErrorVisible?: (error: FormError) => boolean,
  onErrorClick?: (error: FormError) => void,
  customDisplay?: string | JSX.Element,
}
export default function ErrorMessages(props: ErrorMessagesProps) {
  const { t } = useTranslation(['common', 'transition']);
  const { i18n } = useTranslation();
  const { errors } = props;
  const [hasScrolled, setHasScrolled] = useState(false)

  const visibleErrors = errors.filter(error => {
    if (props.isErrorVisible) {
      return props.isErrorVisible(error)
    }
    return true;
  });

  // Sort error messages by question number using format "{Q#}. {error message}"
  // if error.message property has no Q# -> format "{error message}", system will not affect order of returned errors
  const sortErrors = visibleErrors.sort((a, b) => {
    if (a.message === null || !a.message.includes(".") || b.message === null || !b.message.includes(".")) {
      return 0;
    }

    if (Number(a.message.split(".")[0]) > Number(b.message.split(".")[0])) {
      return 1;
    } else if (Number(a.message.split(".")[0]) < Number(b.message.split(".")[0])) {
      return -1;
    } else {
      return 0;
    }
  })

  useEffect(() => {
    if (!hasScrolled && errors.length > 0) {
      const element = document.getElementById('spectral-error-container')
      element?.scrollIntoView({ behavior: 'smooth' })
      setHasScrolled(true)
    } else if (errors.length === 0 && hasScrolled) {
      setHasScrolled(false)
    }
  }, [errors, hasScrolled])

  return (<>
    {errors.length > 0 &&
      <div className="error-container" id='spectral-error-container'>
        {
          props.customDisplay &&
          <p className="error-heading">
            {props.customDisplay}
          </p>
        }
        {
          sortErrors.length > 0 &&
          <>
            {
              (props.showHeader !== false) &&
              <p className="error-heading">
                {
                  (sortErrors.length !== errors.length) &&
                  <>{sortErrors.length} errors on current page. </>
                }
                {t('error-msg-header')}
              </p>
            }
            <ul className="error-list">
              {sortErrors.map((error, idx) => (
                <li key={`${error.primaryKey}-${idx}`}>
                  <FontAwesomeIcon icon={faCircleExclamation} className="error-icon" />
                  <span onClick={() => {
                    if (props.onErrorClick) {
                      props.onErrorClick(error)
                    }
                    const findByName = document.getElementsByName(error.primaryKey)[0];
                    const findById = document.getElementById(error.primaryKey);
                    const findByDataPrimaryKey = document.querySelector(`[data-primary-key="${error.primaryKey}"]`)
                    if (findByName) {
                      findByName.scrollIntoView({ behavior: 'smooth' });
                    } else if (findById) {
                      findById.scrollIntoView({ behavior: 'smooth' })
                    } else if (findByDataPrimaryKey) {
                      findByDataPrimaryKey.scrollIntoView({ behavior: 'smooth' })
                    }
                  }}>{i18n.language === 'fr' ? error.messageFr : error.message}</span>
                </li>
              ))}
            </ul>
          </>
        }
      </div>
    }
  </>)
}